import {
  OBTER_MENU_ATENDIMENTO_VIRTUAL_REQUEST,
  OBTER_MENU_ATENDIMENTO_VIRTUAL_SUCCESS,
} from './constants';

export function obterMenuAtendimentoVirtualRequest() {
  return {
    type: OBTER_MENU_ATENDIMENTO_VIRTUAL_REQUEST,
  };
}

export function obterMenuAtendimentoVirtualSuccess(menuAtendimento) {
  return {
    type: OBTER_MENU_ATENDIMENTO_VIRTUAL_SUCCESS,
    payload: menuAtendimento,
  };
}
